<template>
  <div>
    <b-container fluid>
      <b-row class="row">
        <b-col>To select your target areas by zip code from the map, please enter in the box below a zip code or address, choose a radius (in miles) in the box next to it and click ADD.  We will then present to you a map with zip codes fitting the area and radius that you provided.  Click on the map in order to select or de-select zip codes.</b-col>
      </b-row>
      <div :class="{'map-full-screen-input': fullScreen}">
        <b-row>
          <b-col md="5" style="padding-left: 0px;" sm="12">
            <b-form-input id="mapZipInput"
                          type="text"
                          v-model="address"
                          placeholder="Enter a ZIP Code or Address"
                          @change="addressChange($event)"
                          @keyup.enter.native="search"
                          />
          </b-col>
          <b-col md="1" sm="2" class="flex-center" style="padding-left:0px">
            <span style="margin-right: 8px">Radius:</span>
          </b-col>
          <b-col md="3" sm="6">
            <b-form-input  type="number" v-model="radius" @change="radiusChange($event)" @keyup.enter.native="search"/>
          </b-col>
          <b-col md="2" sm="4">
            <b-btn @click="search" style="margin-left: 16px">Show ZIP Codes</b-btn>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-alert :show="alertDesc!==''" variant="warning">{{alertDesc}}</b-alert>
          </b-col>
        </b-row>

      </div>
      <b-row>
        <b-col>
          <m-map map-id = 'mapZip'
                 @load="createMap"
                 @full-screen="toggleFullScreen"/>
          <span>Please click on the map above to add or remove zip codes</span>
        </b-col>
      </b-row>
    </b-container>
  </div>

</template>
<script>
  import MGeoBox from '@/components/geo/MGeoBox'
  import MMap from '@/components/geo/MMap'
  import utils from '@/assets/utils/index'

  export default {
    name: 'MGeoZipMap',
    components: {
      MGeoBox,
      MMap
    },
    props: {
      geoType: {
        type: Number
      },
      changeGeoType: {
        type: Number,
        default: 5
      },
      pastZipType: {
        type: String,
        default: 0
      }
    },
    data () {
      return {
        map: null,
        radius: '',
        address: '',
        circle: null,
        alertDesc: '',
        geoSlcFitFinish: false,
        fullScreen: false,
        mark: null,
        please: null
      }
    },
    computed: {
      orderGeos () {
        return this.$store.getters['order/geoItems']
      },
      order () {
        return this.$store.state.order
      }
    },
    activated () {
      this.updateMap()
      if (this.order.GeoType === 5 && this.map) {
        this.map.fitZipBounder()
      }
    },
    watch: {
      orderGeos () {
        this.updateMap()
      }
    },
    methods: {
      createMap () {
        this.map = utils.maps['mapZip']
        this.map.addLayer('ZIP', '', true)
        this.map.startSelect(this.changeGeoType)
        this.map.startPolygonAutocomplete('mapZipInput', () => {
          this.place = this.map.autocomplete.getPlace()
          if (this.radius === '') {
            this.markMap()
          } else {
            this.search()
          }
        })
        setTimeout(this.updateMap, 1)
      },
      markMap () {
        if (this.mark) {
          this.mark.setMap(null)
        }
        this.map.map.setZoom(12)
        this.map.map.panTo(this.place.geometry.location)
        this.mark = this.map.marker(this.place.geometry.location)
      },
      search () {
        if (this.pastZipType !== 'zip') {
          this.$store.commit('order/cleanGeo')
          this.$store.commit('order/saveKey', ['ZipType', 0])
        }

        this.alertDesc = ''
        if (this.address.length === 0) {
          this.alertDesc = 'Please enter ZIP Code or address'
          return
        }

        let radius = this.radius
        if (radius === null || radius === '') {
          this.addressChange(this.address)
          return
        } else if (isNaN(radius)) {
          this.alertDesc = 'radius must be a number'
          return
        }
        if (this.mark) {
          this.mark.setMap(null)
        }
        this.map.textSearch(this.address, resp => {
          if (resp.placesresult !== null) {
            this.$store.dispatch('order/changeGeoType', this.changeGeoType)
            this.$store.commit('order/cleanGeo')
            this.map.clearSelecteBounder()
            if (this.circle) {
              this.circle.setMap(null)
            }
            let lng = resp.placesresult.geometry.location.lng()
            let lat = resp.placesresult.geometry.location.lat()
            this.circle = this.map.drawCircle(lng, lat, this.radius)
            this.map.getRadioBounders(lng, lat, this.radius, true)
          } else {
            this.alertDesc = 'No results found for address'
          }
        }, true)
      },
      updateMap () {
        // Avoid update map in other page
        if (this.$route.name !== 'geo-zip') {
          return
        }
        if (!this.map) {
          return
        }
        // add zip bounder in map
        if (this.order.GeoType === 5) {
          for (let geo of this.$store.getters['order/geoItems']) {
            if (geo.GeoType === 5) {
              let isExist = false
              for (let code of Object.keys(this.map.loadPolygons)) {
                if (geo.GeoKeyCode === code) {
                  isExist = true
                  break
                }
              }
              if (!isExist) {
                this.map.getZipBounder(geo.GeoKeyCode, true, true)
              } else {
                if (this.map.loadPolygons[geo.GeoKeyCode]) {
                  // TODO@PONY here are some error about array index
                  this.map.loadPolygons[geo.GeoKeyCode][0].setOptions({
                    strokeOpacity: 0.8,
                    fillOpacity: 0.2
                  })
                }
              }
            }
          }
        }
        // delete zip bounder in map
        for (let code of Object.keys(this.map.loadPolygons)) {
          if (!this.$store.getters['order/hasGeoItem'](code)) {
            for (let item of this.map.loadPolygons[code]) {
              item.setOptions({
                strokeOpacity: 0,
                fillOpacity: 0
              })
            }
          }
          this.map.updateZipBounders()
        }
      },
      toggleFullScreen (val) {
        this.fullScreen = val
      },
      addressChange (val) {
        this.alertDesc = ''
        if (this.radius === '') {
          this.$store.commit('geo/saveKey', ['geoUnAdd', 'radius'])
          this.map.textSearch(val, resp => {
            if (resp.placesresult !== null) {
              this.place = resp.placesresult
              this.markMap()
            } else {
              this.alertDesc = 'No results found for address'
            }
          }, true)
        } else {
          this.search()
        }
      },
      radiusChange () {
        if (this.address !== '' && this.radius !== '') {
          this.search()
        } else {
          this.alertDesc = 'Radius is required!'
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .row{
    margin-top: 16px;
    margin-bottom: 8px;
  }
  .address-input{
    width: 100%;
    display: inline-block;
    float: right;
  }
  .address-type{
    margin-left: 8px;
  }

  .header {
    display: flex;
    justify-content: space-between;
  }

  .box-t {
    border: 1px solid $color-border;
    border-radius: 8px;
    background-color: $color-background;
    padding: 16px;
    width: 100%;
    margin-bottom:16px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/geo/MGeoZipMap.vue